import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/index'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  /* 如果在白名单里面则直接通过*/
  if (whiteList.indexOf(to.path) === 0 || to.path.indexOf('/index') === 0) {
    next()
    return
  }
  /* 如果访问登陆页面则清除当前登陆信息*/
  if (to.path.indexOf('/login') === 0 || to.path.indexOf('/logout') === 0) {
    next()
    return
  }

  /* 没有验证成功则进入登陆页面*/
  next(`/login?redirect=${to.path}`)
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
